module.exports = __webpack_public_path__ + "img/status_finished.9ffe4614.png";